<template>
  <div >

    <!--<div style="position: relative; z-index: -1" width="100%">-->
      <!--<v-img src="../assets/images/content/math.png"  ></v-img>-->
    <!--</div>-->

    <nav-bar></nav-bar>

    <Section background="black"  class="image-bg"
             :style="{'background-image': `url(${require('../assets/images/content/background-purple-line.png')})`}"
    >

      <div class="main-heading" :style="heading_height">
        <div class="heading-line"
        >
          <div class="center" :class="getC_heading">Our Services</div>

          <v-container style="max-width: 800px" :class="getC_subheading">
            <v-row justify="center" align="center" >
              <v-col>
                <a href="#services-consulting" class="plain-link">CONSULTING</a>
              </v-col>
              <v-col>
                <a href="#services-analytics" class="plain-link">DATA ANALYTICS</a>

              </v-col>
              <v-col>
                <a href="#services-development" class="plain-link">DEVELOPMENT</a>

              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>



    </Section>



    <!-------------------------------------------Consulting------------------------------------------------------------>

    <a id="services-consulting"></a>
    <div class="section-container" >


      <div class="heading-container" v-if="show_side_headings">
             <span class="side-headings" >
            CONSULTING
          </span>
      </div>

      <div v-else class="empty_size_heading"></div>

      <div class="content-container ">

        <div v-if="!show_side_headings" class="top-headings display-1" >
          CONSULTING
        </div>


        <v-container>


          <v-row justify="center" align="start">

            <v-col cols="12"  class="content-text">

              <div style="display:block">

                <p>
                  <img src="../assets/images/tmp/what_why_how.png"  class="floated-image">
                  Today, Data Science is all the rage, just like the internet was in the 90's.
                  And just like the internet, it will be a required technology of tomorrow's business.
                  But in the mean time, being an early adopter brings with it both reward and risk.
                  <span class="ref_object" @click="show_dialog_ref=true">(Only about 15% of data science projects actually deliver any value<sup>1</sup>).</span>
                </p>



                <p>
                  <!--We created Espy Data Science because we got tired of seeing companies being sold marketing fluff with no real value.-->
                  That's why we <span style="font-weight: bold">guarantee our results</span>.
                  In a world of failed projects and broken promises, we think the best way to cut through the BS is to
                  tie our bottom line to yours.  Hence, we start every consulting project by asking one question:
                  Can we deliver a true ROI for our client?
                  If we think we can, well then it's on us to deliver.  Because if we don't, you get your money back.
                </p>





              </div>
            </v-col>

          </v-row>
        </v-container>
      </div>
    </div>





    <!-- dialog for reference------>
    <v-dialog v-model="show_dialog_ref" max-width="70%" >


      <v-card>
        <v-card-title>
          1 Data Science Success Rates
        </v-card-title>
        <v-card-text style="color: white">


          <p>
            According to a review article by Designing For Analytics, the success rate for data analytics projects varies
            from about 13% (VentureBeat AI) to 26% (Cisco) depending on the reporting source.
          </p>

          <p>
            According to a study by PWC (reported by CIO magazine),
            <span style="font-style: italic">Overall, 43 percent of companies surveyed "obtain little tangible benefit
              from their information," while 23 percent "derive no benefit whatsoever," according to the study.</span>
          </p>

          <p>
            See references below for more information
          </p>

          Source: Designing for Analytics, "Failure rates for analytics, AI, and big data projects = 85% – yikes!", July 2019 <br>
          <a href="https://designingforanalytics.com/resources/failure-rates-for-analytics-bi-iot-and-big-data-projects-85-yikes/"
             target="_blank">
            https://designingforanalytics.com/resources/failure-rates-for-analytics-bi-iot-and-big-data-projects-85-yikes/
          </a>

          <br>
          Source: CIO Magazine, "Study reveals that most companies are failing at big data", Nov 2015<br>
          <a href="https://www.cio.com/article/3003538/study-reveals-that-most-companies-are-failing-at-big-data.html"
             target="_blank">
            https://www.cio.com/article/3003538/study-reveals-that-most-companies-are-failing-at-big-data.html
          </a>

        </v-card-text>

      </v-card>


    </v-dialog>











    <!-------------------------------------------Analytics------------------------------------------------------------>
    <a id="services-analytics"></a>
    <div class="section-container mt-4 " >

      <div class="heading-container" v-if="show_side_headings">
             <span class="side-headings">
            DATA ANALYTICS
          </span>
      </div>
      <div v-else class="empty_size_heading"></div>


      <div class="content-container">

        <div v-if="!show_side_headings" class="top-headings display-1" >
          DATA ANALYTICS
        </div>


        <v-container>
          <v-row justify="center" align="stretch">

            <v-col cols="12" align="center" style="max-width:600px">
              <img src="../assets/images/tmp/ef193c8dfe5d3fffcab1ba467a8d63e3.png">
            </v-col>
          </v-row>
          <v-row justify="center" align="stretch">




            <v-col cols="12"  class="content-text">
              Have a question that your data holds the answer to?  Our team of experts have decades of experience
              and training in AI, Machine Learning, Time Series, and Regression techniques, and can craft the ideal
              solution to meet your analytical needs.

              Having built  solutions for the Energy, Banking, Automotive, and Marketing industries,
              we're able to tailor our technical expertise to your individual needs.

              <!--We've built solutions for the Energy, Banking, Automotive, and Marketing industries, and so far-->
               <!--our customers have had nice things to say.  So let us know what your analytical needs are and we'll-->
              <!--start working on the solution.-->

            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>



    <!-------------------------------------------Development------------------------------------------------------------>
    <a id="services-development"></a>
    <div class="section-container mt-4 mb-4" >

      <div class="heading-container" v-if="show_side_headings">
             <span class="side-headings">
            DEVELOPMENT
          </span>
      </div>
      <div v-else class="empty_size_heading"></div>


      <div class="content-container">


        <div v-if="!show_side_headings" class="top-headings display-1" >
          DEVELOPMENT
        </div>


        <v-container>

          <v-row justify="center" align="stretch">
            <v-col cols="12"  class="quote">
              "The first rule of any technology used in a business is that automation applied to an efficient
              operation will magnify the efficiency.
              The second is that automation applied to an inefficient operation will magnify the inefficiency."
              <div class="quote" style="text-align:right; width:100%">- Bill Gates</div>
            </v-col>
          </v-row>

          <v-row justify="center" align="stretch">
            <v-col cols="12"  class="content-text">
              Data analytics provides insight.  But when paired with the right technology, its value
              increases exponentially.  Whether you need a simple dashboard integrated to an existing tool like
              Tableau™, automation of Excel™ spreadsheets, or even a fully custom application, our development team had decades of experience building
              modern Web, Cloud, and On-Prem applications.

            </v-col>
          </v-row>

          <v-row justify="center" align="center" style="max-width:900px;margin:auto;">

            <v-col :cols="logo_cols" align="center" >
              <img src="../assets/images/logos-others/python.png">
            </v-col>
            <v-col :cols="logo_cols" align="center" >
              <img src="../assets/images/logos-others/scikit-learn.png">
            </v-col>
            <v-col :cols="logo_cols" align="center" >
              <img src="../assets/images/logos-others/numpy.png">
            </v-col>
            <v-col :cols="logo_cols" align="center" >
              <img src="../assets/images/logos-others/matplotlib.png">
            </v-col>
            <v-col :cols="logo_cols" align="center" >
              <img src="../assets/images/logos-others/pandas_new.jpg">
            </v-col>

            <v-col :cols="logo_cols" align="center" >
              <img src="../assets/images/logos-others/tensorflow.png">
            </v-col>
            <v-col :cols="logo_cols" align="center" >
              <img src="../assets/images/logos-others/node.png">
            </v-col>
            <v-col :cols="logo_cols" align="center" >
              <img src="../assets/images/logos-others/vue.jpg">
            </v-col>
            <v-col :cols="logo_cols" align="center" >
              <img src="../assets/images/logos-others/React_logo_wordmark.png">
            </v-col>

            <v-col :cols="logo_cols" align="center" >
              <img src="../assets/images/logos-others/mongo.png">
            </v-col>

            <v-col :cols="logo_cols" align="center" >
              <img src="../assets/images/logos-others/aws.jpg">
            </v-col>

            <v-col :cols="logo_cols" align="center" >
              <img src="../assets/images/logos-others/digital-ocean.png">
            </v-col>
          </v-row>


        </v-container>
      </div>
    </div>







    <!--<div class="process-section">-->

      <!--some extra space for the moment-->

    <!--</div>-->



  </div>

</template>






<style scoped lang="scss">



  .image-bg{
    background-size: cover;
    background-position: center;
  }


  /*.main-heading{*/
    /*height: 450px;*/
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: center;*/

  /*}*/

  .heading-line{
    text-align: center;
    width: 100%
  }



  .main-heading{
    /*min-height: 350px;*/
    display: flex;
    align-items: center;
    justify-content: center;
    /*background-image: url('../assets/images/content/math.png')*/

    }




  .plain-link{
    color: white;
    text-decoration: none;

  }

  .ref_object{
    cursor: pointer;
  }


  .section-container{

    display: flex;
    min-height: 300px;
    width: 100%;
    /*max-width: 1000px;*/
    /*margin: auto;*/


    /*background: blue;*/
    .heading-container{
      width: 70px;
      min-height: 100%;
      position: relative;
      /*background: red;*/


      .side-headings{
        //https://stackoverflow.com/questions/15138723/vertically-center-rotated-text-with-css
        position: relative;
        top: 50%;
        left: 50%;
        font-size: 2em;
        /*text-align: center;*/
        display:inline-block;
        /*transform-origin: 0 0;*/

        white-space: nowrap;
        transform:  translateX(-50%)  translateY(-50%) rotate(-90deg);

      }

    }

    .empty_size_heading{
      width: 20px;
    }

    .top-headings{
      width: 100%;
      color: black;
      padding-left: 10px;

    }



    .content-container{
      background: #ffffff;
      width: 100%;
      padding-top: 30px;
      padding-bottom: 30px;

      color: black;
      margin-right: 20px;


      .content-text{
        display: flex;
        font-size: 1.4em;
        max-width: 900px;
        text-align: justify;
        /*margin: auto;*/
      }
    }


  }


  img{
    width: 100%;
  }

  .quote{
    max-width: 700px;
    font-style: italic;
    font-size: 0.8em;
  }



  .floated-image{
    float: right;
    max-width: 200px;
    background: red;
    margin-left: 20px;
  }







</style>


<script>
// @ is an alias to /src
import Section from '@/components/Section.vue';
import Contact from '@/components/ContactForm.vue';
import navBar from '@/components/navBar.vue';


export default {
  name: 'home',
  components: {navBar, Section, Contact, },
   data(){return {
      show_dialog_ref: false,

   }},

   computed:{
     logo_cols(){
        if (['xs',].includes(this.$vuetify.breakpoint.name)) {
           return 4;
        }
        else if (['sm'].includes(this.$vuetify.breakpoint.name)) {
           return 2;
        }
        else{
           return 2;
        }

     },


      /**
       * sets height of top banner based on breakpoints
       */
     heading_height(){
        if (['xs',].includes(this.$vuetify.breakpoint.name)) {
           return 'min-height: 250px;';
        }
        else if (['sm'].includes(this.$vuetify.breakpoint.name)) {
           return 'min-height: 300px;';
        }
        else{
           return 'min-height: 350px;';
        }
     },

      /**
       * Sets settings for the service heading text
       */
     getC_heading(){
        if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)) {
           return 'display-2 pt-1 pb-3';
        }
        else{
           return 'display-3 pt-1 pb-7';
        }
     },

      /**
       * Sets settings for the subheadings
       *
       */
      getC_subheading(){
         if (['xs',].includes(this.$vuetify.breakpoint.name)) {
            return 'pt-5';
         }
         else if (['sm'].includes(this.$vuetify.breakpoint.name)) {
            return 'pt-3 title';
         }
         else{
            return 'pt-7 headline';
         }
      },

      show_side_headings(){
         if (['xs', ].includes(this.$vuetify.breakpoint.name)) {
            return false;
         }
         return true;
      }

   },//computed

}
</script>
